
// Usage  <div onTouchStart={() => longPress.touchStart()} onTouchEnd={() => longPress.touchEnd()}></div> 
export class LongPress {

  static timer?: NodeJS.Timeout;

  constructor(public action: () => void) {
  }

  touchStart() {
    LongPress.timer = setTimeout(() => {
      this.action();
    }, 1000)
  }

  touchEnd() {
    if (LongPress.timer)
      clearTimeout(LongPress.timer);
  }
}